import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogDescription, DialogTitle } from "@/components/ui/dialog";
import InquiryForm from "@/components/InquiryForm";
import { CONTACT } from "@/data/content";

const InquiryModal = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const openModal = () => setOpen(true);
    window.addEventListener("open-inquiry", openModal);
    return () => window.removeEventListener("open-inquiry", openModal);
  }, []);

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogContent
        className="sm:max-w-xl bg-[#F5F2EB] border-border rounded-none p-8 md:p-10 max-h-[90vh] overflow-y-auto"
        data-testid="inquiry-modal"
      >
        <DialogTitle className="font-heading font-light tracking-tight text-3xl md:text-4xl text-foreground">
          Plan my <em className="text-primary">journey.</em>
        </DialogTitle>
        <DialogDescription className="text-sm font-light text-foreground/70">
          Group batches leave every Sunday from Bagdogra. Leave your details —
          a TrekPanda travel expert calls you within 24 hours. Prefer chatting?{" "}
          <a href={CONTACT.whatsapp} target="_blank" rel="noopener noreferrer" className="text-primary border-b border-primary/40" data-testid="inquiry-modal-whatsapp-link">
            WhatsApp us
          </a>
        </DialogDescription>
        <InquiryForm
          idPrefix="inquiry-modal"
          onSubmitted={() => setTimeout(() => setOpen(false), 1400)}
        />
      </DialogContent>
    </Dialog>
  );
};

export default InquiryModal;
